import type { UserRead } from '@gridcon-energy/schaltungstool-backend'

/**
 * Extend SessionData to match our custom User type
 */
declare module '#auth' {
  interface SessionData extends UserRead {}
}

export const AuthRedirects = {
  login: '/auth/login', // if login needed
  home: '/', // after successful login
  logout: '/auth/login', // after logout
} as const

/**
 * https://auth.sidebase.io/guide/application-side/protecting-pages#guest-mode
 */
export const GuestMode = {
  unauthenticatedOnly: true,
  navigateAuthenticatedTo: AuthRedirects.home,
}
